function DayService($q, BBModel) {
    'ngInject';

    return {
        query
    };


    function query(prms) {

        const deferred = $q.defer();

        if (prms.cItem.days_link) {

            const extra = {};
            extra.month = prms.month;
            extra.date = prms.date;
            extra.edate = prms.edate;
            if (prms.people_ids) {
                extra.people_ids = prms.people_ids;
            }
            if (prms.resource_ids) {
                extra.resource_ids = prms.resource_ids;
            }
            if (prms.person_group_id) {
                extra.person_group_id = prms.person_group_id;
            }

            prms.cItem.days_link.$get('days', extra).then((found) => {

                    const afound = found.days;
                    let days = [];

                    function findDay(daysArray) {
                        // Get all days that have spaces
                        const daysWithSpaces = daysArray.filter( day => day.spaces > 0 );

                        if (daysWithSpaces.length) {
                            // Return a random day that has spaces
                            const max = daysWithSpaces.length;

                            // Random example from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
                            const index = Math.floor(Math.random() * Math.floor(max));
                            return daysWithSpaces[index];
                        } else {
                            // Return a day with no spaces
                            return daysArray[0];
                        }
                    }

                    days = _.chain(afound)
                        .filter(day => day.type === prms.item)
                        .map(day => new BBModel.Day(day))
                        .groupBy(day => day.date.toISODate())
                        .map(days => findDay(days))
                        .flatten()
                        .value();

                    markSelectedItemAsAvailable(days, prms.cItem);

                    return deferred.resolve(days);
                }

                , (err) => {
                    return deferred.reject(err);
                }
            );

        } else {

            deferred.reject('No \'days\' link found');

        }

        return deferred.promise;
    }

    function markSelectedItemAsAvailable(days, basketItem) {

        function isDateValid(day, basketItem) {
            return basketItem.date && day.event_id === basketItem.event_id && day.date.isSame(basketItem.date.date);
        }

        for (const day of days) {
            if ((basketItem.held && isDateValid(day, basketItem.held)) || isDateValid(day, basketItem)) {
                day.spaces = 1;
            }
        }

    }

}

/**
 * @ngdoc service
 * @name BB.Services:DayService
 *
 * @description
 * Retrieves available days for services.
 */
angular
    .module('BB')
    .service('DayService', DayService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/day.service.js